/**
 * Media log entry point. The page is complete without this file: filters, sorting, search
 * and pagination are all links and forms. What loads here is the theme toggle, and -- only
 * when the server rendered the page for an admin session -- the edit controls.
 */

import { initLightbox } from '../home/lightbox.js';
import { initThemeToggle } from '../home/theme-toggle.js';

initThemeToggle(document.querySelector('.theme-toggle'));
// Covers open big, exactly like the favorites shelf -- same script, same dialog.
initLightbox(document.querySelector('.lightbox'), document.querySelector('.log'));

if (document.body.hasAttribute('data-admin')) {
  // Static import would ship admin code to every visitor for nothing.
  import('./admin.js').then(({ initAdmin }) => initAdmin());
}
